import { Bar, Line } from "react-chartjs-2";
import { useChartData } from "./useChartData";
import dayjs from "dayjs";

const ChartBase = ({
  chartType = "bar", // bar | line
  dailyMap,
  startDate,
  endDate,
  mode = "raw", // raw | cal
  field,
  cal1,
  cal2,
  label,
  unit,
  currency,
  usdRate,
  cpm,
  color = "#482979",
}) => {
  const { labels, data } = useChartData({
    dailyMap,
    startDate,
    endDate,
    type: mode,
    field,
    cal1,
    cal2,
    unit,
    currency,
    usdRate,
    cpm
  });

const displayLabels = labels.map((_, index) =>
  dayjs(startDate)
    .add(index, "day")
    .format("ddd DD/MM") // vd: T6 02/03
);


  const ChartComponent = chartType === "bar" ? Bar : Line;

  return (
    <ChartComponent
      data={{
        labels: displayLabels,
        datasets: [
          {
            label,
            data,
            backgroundColor:
              chartType === "bar" ? color : `${color}33`,
            borderColor: color,
            borderRadius: 6,
            tension: 0.4,
            fill: chartType === "line",
          },
        ],
      }}
      options={{
        responsive: true,
        animation: false,
        plugins: {
          tooltip: {
            callbacks: {
              // 👉 Tooltip hiện đầy đủ thứ + ngày
             title: ctx =>
                dayjs(startDate)
              .add(ctx[0].dataIndex, "day")
              .format("dddd, DD/MM/YYYY"),
              label: ctx =>
                `${ctx.raw.toLocaleString()} ${unit}`,
            },
          },
          legend: {
            labels: {
              font: {
                size: 20,
              },
            },
          },
        },
        scales: {
          x: { grid: { display: false } },
          y: { beginAtZero: true },
        },
      }}
    />
  );
};

export default ChartBase;
